/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyDto } from '../models/CompanyDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompaniesService {
  /**
   * 모든 회사 가져오기
   * @returns CompanyDto
   * @throws ApiError
   */
  public static companyControllerCompanies(): CancelablePromise<
    Array<CompanyDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/companies',
    });
  }
}
